import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ChatService } from 'src/app/services/chat.service';

@Component({
  selector: 'app-support-settings',
  templateUrl: './support-settings.component.html',
  styleUrls: ['./support-settings.component.scss']
})
export class SupportSettingsComponent {
  settings: any = {};

  constructor(private chatService: ChatService) { }

  async ngOnInit() {
    this.settings = await this.chatService.getSettings('support');
  }

  async save(json?: string) {
    if (json)
      this.settings = JSON.parse(json);
    this.settings = await this.chatService.saveSettings('support', this.settings);

  }

}
